// extracted by mini-css-extract-plugin
export default {"actionBtn":"ActionsList_actionBtn__lqPa1","noMarginRight":"ActionsList_noMarginRight__zKHtp"};